<div oui-dialog-title>
  Confirmer l'annulation de la procédure
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="dialog-content">
  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  } @else {
    Êtes-vous sur de vouloir annuler votre procédure de résiliation ? Cette action est
    définitive une fois confirmée.
  }
</oui-dialog-content>

<oui-dialog-actions class="dialog-actions">
  <oui-button type="text" [disabled]="isLoading()" oui-dialog-close>Fermer</oui-button>
  <oui-button [disabled]="isLoading()" (click)="cancelResiliation()"
    >Confirmer</oui-button
  >
</oui-dialog-actions>
